/**
 * "The interactive console" — CLI section (ADR-0439).
 * Reconciled from packages/cli/src/tui (should-launch, screens, ports).
 */
import type { DocPageContent } from '../types';

export const CLI_CONSOLE_PAGE: DocPageContent = {
  slug: 'cli/console',
  titleKey: 'docs.cli.console.title',
  descriptionKey: 'docs.cli.console.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.cli.console.lead' },
    { kind: 'code', language: 'bash', code: 'npx syncanix' },

    {
      kind: 'callout',
      tone: 'note',
      textKey: 'docs.cli.console.scriptsUnchanged',
    },

    { kind: 'heading', level: 2, id: 'signing-in', textKey: 'docs.cli.console.signIn.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.console.signIn.body' },
    { kind: 'paragraph', textKey: 'docs.cli.console.signIn.guest' },

    { kind: 'heading', level: 2, id: 'what-you-can-do', textKey: 'docs.cli.console.does.heading' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.cli.console.does.catalog.term',
          descKey: 'docs.cli.console.does.catalog.desc',
        },
        {
          termKey: 'docs.cli.console.does.compare.term',
          descKey: 'docs.cli.console.does.compare.desc',
        },
        { termKey: 'docs.cli.console.does.sync.term', descKey: 'docs.cli.console.does.sync.desc' },
        {
          termKey: 'docs.cli.console.does.capabilities.term',
          descKey: 'docs.cli.console.does.capabilities.desc',
        },
        {
          termKey: 'docs.cli.console.does.content.term',
          descKey: 'docs.cli.console.does.content.desc',
        },
        { termKey: 'docs.cli.console.does.keys.term', descKey: 'docs.cli.console.does.keys.desc' },
        { termKey: 'docs.cli.console.does.scan.term', descKey: 'docs.cli.console.does.scan.desc' },
        {
          termKey: 'docs.cli.console.does.generate.term',
          descKey: 'docs.cli.console.does.generate.desc',
        },
        {
          termKey: 'docs.cli.console.does.workspace.term',
          descKey: 'docs.cli.console.does.workspace.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'gates', textKey: 'docs.cli.console.gates.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.console.gates.body' },
    {
      kind: 'callout',
      tone: 'important',
      textKey: 'docs.cli.console.gates.dualControl',
    },

    { kind: 'heading', level: 2, id: 'opting-out', textKey: 'docs.cli.console.optOut.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.console.optOut.body' },
    { kind: 'code', language: 'bash', code: 'SYNCANIX_NO_TUI=1 npx syncanix' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.cli.console.next.generate.title',
          textKey: 'docs.cli.console.next.generate.text',
          to: { docSlug: 'cli/generate' },
        },
        {
          titleKey: 'docs.cli.console.next.commands.title',
          textKey: 'docs.cli.console.next.commands.text',
          to: { docSlug: 'cli/commands' },
        },
      ],
    },
  ],
};
